import React, { createContext, useContext } from 'react';

import { Filters } from '@work4all/models/lib/DataProvider';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { EntityPickerPopover } from '../entity-picker/components/EntityPickerPopover';

import { SimplePDFReportProps } from './interfaces/SimpleReportErpTypes';

export interface TemplateEntity {
  entity: Entities;
  ids: (string | number)[];
}

export interface FooterPickerAction<TValue> {
  disableAddButton?: boolean;
  hideAddButton?: boolean;
  disableListButton?: boolean;
  hideListButton?: boolean;
  entity: Entities;
  data?: TValue;
  onChange?: (value: TValue | TValue[]) => void;
  popoverRef: React.RefObject<EntityPickerPopover>;
  template?: TemplateEntity;
  presetFields?: TValue;
  prefilter?: Filters;
  forceRequestFields?: TValue;
}

interface IEntityTemplateProviderContext {
  renderPickerFooter: <T>(
    props: FooterPickerAction<T>
  ) => React.ReactElement<any>;
  renderSimpleReport: (props: SimplePDFReportProps) => React.ReactElement<any>;
}

const EntityTemplateProviderContext =
  createContext<IEntityTemplateProviderContext>({
    renderPickerFooter: () => null,
    renderSimpleReport: () => null,
  });

export const EntityTemplateProvider = ({
  children,
  ...props
}: React.PropsWithChildren<IEntityTemplateProviderContext>) => {
  return (
    <EntityTemplateProviderContext.Provider value={props}>
      {children}
    </EntityTemplateProviderContext.Provider>
  );
};

export const useEntityTemplate = () =>
  useContext(EntityTemplateProviderContext);
